import { IIdName } from '@/interfaces/general/IIdName.ts';

export const aggregateGranularities: Array<IIdName> = [
    {
        id: 'none',
        name: 'None',
        info: '',
    },
    {
        id: 'halfHourly',
        name: 'Half-Hour',
        info: 'half hourly ',
    },
    {
        id: 'hour',
        name: 'Hour',
        info: 'hourly ',
    },
    {
        id: 'day',
        name: 'Day',
        info: 'daily ',
    },
    {
        id: 'week',
        name: 'Week',
        info: 'weekly ',
    },
    {
        id: 'month',
        name: 'Month',
        info: 'monthly ',
    },
];

export const aggregateTypes: Array<IIdName> = [{
    id: 'none',
    name: 'None',
}, {
    id: 'average',
    name: 'Average',
}, {
    id: 'min',
    name: 'Min',
}, {
    id: 'max',
    name: 'Max',
}, {
    id: 'sum',
    name: 'Sum',
}, {
    id: 'spread',
    name: 'Spread',
}, {
    id: 'standardDeviation',
    name: 'Standard Deviation',
}, {
    id: 'variance',
    name: 'Variance',
}];
